import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ApsContainer, ApsContentContainer, ApsPageTitle } from "UserExperience/portal-vnext";
import DocumentPagesAPI from "./DocumentPagesAPI";
import {isMobile} from 'react-device-detect';
import { useSession } from "../../common/session/SessionContext";
import TranslatedContentAPI from "../HomeAPI/TranslatedContent/TranslatedContentAPI";
import BrandedContentAPI from "../HomeAPI/Content/BrandedContent/BrandedContentAPI";

const AddDocumentAPI = props => {

  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { activeDocument, language } = useSession();
  
  if(i18n.language !== undefined && i18n.language !== language){
  i18n.changeLanguage(language);
  }

  let pageTitle = t('addDocumentScreen.title');
  if(pageTitle === 'addDocumentScreen.title'){
    pageTitle = 'Add Document';
  }

  if (!activeDocument) {
    history.goBack();
  }

  const goBack = () => {
    history.goBack();
  }  

  return (
    <>
       <TranslatedContentAPI>
        <BrandedContentAPI>
      <ApsPageTitle titleText={pageTitle} />

      <ApsContentContainer containerPadding={true}>
        <ApsContainer
          containerPadding={true}
          containerType="content"
        >
          <DocumentPagesAPI
            document={activeDocument}
            isMobile={isMobile}
            headerTitleAlign="center"
            headerTitleSize="small"
            onFinish={goBack}
            onCancel={goBack}
          />
        </ApsContainer>
      </ApsContentContainer>
      </BrandedContentAPI>
      </TranslatedContentAPI>
    </>
  );
}

export default AddDocumentAPI;